import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export function StickyMobileCTA({ label = 'Kostenlos starten', to = '/signup', hint = 'Ohne Kreditkarte', onClick }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setShow(max > 0 && window.scrollY / max > 0.4);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div data-testid="sticky-mobile-cta" aria-hidden={!show}
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 p-3 transition-transform duration-300 ${show ? 'translate-y-0' : 'translate-y-full'}`}>
      <Link to={to} onClick={onClick} data-testid="sticky-mobile-cta-link"
        className="flex items-center justify-between rounded-2xl bg-[#062417] px-5 py-3.5 text-white shadow-2xl shadow-emerald-900/40 ring-1 ring-white/10">
        <span>
          <span className="block font-semibold">{label}</span>
          <span className="block text-xs text-emerald-200/80">{hint}</span>
        </span>
        <ArrowRight className="h-5 w-5" />
      </Link>
    </div>
  );
}

export default StickyMobileCTA;
